(function () {
  const blockedLabelPattern = /\b(add\s+(?:all\s+)?to\s+cart|checkout|check\s+out)\b/i;
  const blockedHrefPattern = /\/(?:cart|checkout)(?:\/|$|\?)/i;
  const blockedRequestPattern = /\/(?:cart\/(?:add|change|update|clear)(?:\.js)?|checkout|checkouts)(?:\/|$|\?)/i;

  function normalizedText(element) {
    const text = [
      element.textContent,
      element.value,
      element.getAttribute && element.getAttribute('aria-label'),
      element.getAttribute && element.getAttribute('title'),
      element.getAttribute && element.getAttribute('data-testid'),
      element.getAttribute && element.getAttribute('data-test-id'),
    ]
      .filter(Boolean)
      .join(' ');

    return text.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isBlockedAction(element) {
    if (!element) return false;

    const label = normalizedText(element);
    if (blockedLabelPattern.test(label)) return true;

    const href = element.getAttribute && element.getAttribute('href');
    if (href && blockedHrefPattern.test(href) && /checkout|check out|add (all )?to cart/i.test(label)) return true;

    return false;
  }

  function hideAction(element) {
    if (!isBlockedAction(element)) return;

    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('tabindex', '-1');
    element.dataset.windowShoppingBlockedPurchase = 'true';

    if ('disabled' in element) {
      element.disabled = true;
    }

    element.style.setProperty('display', 'none', 'important');
  }

  function hidePurchaseActions() {
    document
      .querySelectorAll('button, a, input[type="button"], input[type="submit"], [role="button"], [onclick]')
      .forEach(hideAction);
  }

  function isBlockedUrl(input) {
    const rawUrl = typeof input === 'string' ? input : input && input.url;
    if (!rawUrl) return false;

    try {
      const url = new URL(rawUrl, window.location.origin);
      return blockedRequestPattern.test(url.pathname + url.search);
    } catch (error) {
      return blockedRequestPattern.test(rawUrl);
    }
  }

  function blockPurchaseAttempt(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener(
    'click',
    function (event) {
      const target = event.target.closest('button, a, input[type="button"], input[type="submit"], [role="button"], [onclick]');
      if (!isBlockedAction(target)) return;

      blockPurchaseAttempt(event);
      hideAction(target);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form || !isBlockedUrl(form.getAttribute('action'))) return;

      blockPurchaseAttempt(event);
    },
    true
  );

  const nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      if (isBlockedUrl(input)) {
        return Promise.reject(new Error('Purchasing is disabled in Window Shopping Mode.'));
      }

      return nativeFetch.apply(this, arguments);
    };
  }

  const nativeOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  const nativeSend = window.XMLHttpRequest && window.XMLHttpRequest.prototype.send;
  if (nativeOpen && nativeSend) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.windowShoppingBlockedPurchaseRequest = isBlockedUrl(url);
      return nativeOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.windowShoppingBlockedPurchaseRequest) {
        this.abort();
        return;
      }

      return nativeSend.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hidePurchaseActions);
  } else {
    hidePurchaseActions();
  }

  new MutationObserver(hidePurchaseActions).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setInterval(hidePurchaseActions, 500);
})();
